export default __webpack_public_path__ + "static/media/quickbooks.991be5f2.png";